<template>
  <v-container>
    <div class="form-control">
      <input type="text" placeholder="Search" v-model="search" style="max-width: 300px" />
    </div>
    <v-data-table
      v-bind:pagination.sync="pagination"
      :headers="headers"
      :loading="loading"
      :items="filterStudents"
      :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      :rows-per-page-text="$t('Rows per page')"
      class="elevation-1"
      item-key="userid"
    >
      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.age }}</td>
          <td>{{ props.item.gender }}</td>
          <td>{{ props.item.job }}</td>
          <td>{{ props.item.last_challenge }}</td>

          <td>{{ props.item.register_date | DateFormat('DD/MM/YYYY HH:mm a') }}</td>
          <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm a') }}</td>
          <td>
            <v-btn small fab flat
              ><v-icon>{{
                !props.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
              }}</v-icon></v-btn
            >
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <v-card flat class="grey lighten-4">
          <v-card-text>
            <div class="text-xs-center" v-if="props.item.score.length == 0">No score</div>
            <table
              v-else
              style="border: 1px solid #eee"
              class="white zw-table fullwidth strip border-radius outline"
            >
              <thead>
                <tr>
                  <td class="font-weight-bold">Chapter</td>
                  <td class="text-xs-center font-weight-bold">Score</td>
                  <td class="text-xs-center font-weight-bold">Fullscore</td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(score, index) in props.item.score">
                  <tr :key="`${props.item.userid}_score_${index}`">
                    <td>{{ score.chapter }}</td>
                    <td class="text-xs-center">{{ score.score }}</td>
                    <td class="text-xs-center">{{ score.full_score }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      loading: true,
      search: '',
      students: [],
      headers: [
        { value: 'name', text: 'Name' },
        { value: 'age', text: 'Age' },
        { value: 'gender', text: 'Gender' },
        { value: 'job', text: 'Job' },
        { value: 'last_challenge', text: 'Last Challenge' },
        { value: 'register_date', text: 'Register Date' },
        { value: 'timestamp', text: 'Timestamp' },
        { text: '', sortable: false }
      ],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 10 }
    }
  },
  async mounted() {
    this.loading = true
    try {
      var response = await this.getipststudent()
      if (response.data) this.students = response.data
    } catch (error) {
      console.error(error)
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterStudents() {
      var students = this.students
      if (this.search.trim() != '') {
        students = students.filter((el) => {
          return (
            (el.name && el.name.toLowerCase().includes(this.search.trim().toLowerCase())) ||
            (el.last_challenge &&
              el.last_challenge.toLowerCase().includes(this.search.trim().toLowerCase()))
          )
        })
      }

      return students
    }
  },
  methods: {
    getipststudent() {
      return new Promise((resolve, reject) => {
        api.getipststudent({ pageid: this.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/atomicboy/AtomicStudentSummary.vue